
function _addMeToCart(e, el) {
    e = e || window.event;
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    let formData = {
        'items': [{
            'id': el.dataset.variant_id,
            'quantity': 1
        }]
    };

    fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then((resp) => {
            return resp.json();

        })
        .then((data) => {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            document.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    variant: el.dataset.variant_id,
                    quantity: 1
                }

            }));
        })
        .catch((err) => {
            console.error('Error: ' + err);
        })
}




var modal = document.querySelector(".Wishlist_Modal");
var trigger = document.querySelector(".Wishlist_model_trigger");
var overlay = document.querySelector(".PageOverlay");

function toggleModal(e) {

    modal.classList.toggle("show-wishlist-modal");
    overlay.classList.toggle("is-visible");
    e.stopPropagation();

}

if (modal) {
    overlay.addEventListener('click', function(e) {
        if (modal.classList.contains('show-wishlist-modal')) {
            modal.classList.remove("show-wishlist-modal");
            overlay.classList.remove("is-visible");

        }

    });
}
if (trigger) {
    trigger.addEventListener("click", toggleModal);
}

var playPause = document.getElementById('video_btn');
var vid = document.querySelector('.product_video');
if (playPause) {
    playPause.addEventListener('click', function(e) {
        e.preventDefault();
        if (!vid.paused) {
            vid.pause();
        } else {
            vid.play();
        }
        playPause.classList.toggle('play');
        playPause.classList.toggle('pause');
        return false;
    }, false);

}

var SortFilter = document.querySelector('.collection-filter-drawer');
var SortFilterClose = document.querySelector('.collection-filter-drawer-close');
var SortFilterDrawer = document.querySelector('.CollectionFilters');

var toggleState = function(elem, one, two) {
    var elem = document.querySelector(elem);
    elem.setAttribute('aria-hidden', elem.getAttribute('aria-hidden') === one ? two : one);
};
if (SortFilter) {
    SortFilter.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleState('#collection-filter-drawersort', 'true', 'false');
        SortFilterDrawer.classList.add("show-sort-modal");
    };

}
if (SortFilterClose) {
    SortFilterClose.onclick = function(e) {
        toggleState('#collection-filter-drawersort', 'true', 'false');
        SortFilterDrawer.classList.remove("show-sort-modal");
        e.preventDefault();
    };
}
if (SortFilter) {
    window.addEventListener('click', function(event) {
        if (SortFilterDrawer.classList.contains('show-sort-modal')) {
            SortFilterDrawer.setAttribute("aria-hidden", "true");

        }
    });
}


var SortFilterMain = document.querySelector('.collection-filter-drawer-main');
var SortFilterDrawerMain = document.querySelector('.CollectionFiltersMain');

var SortFilterCloseMain = document.querySelector('.collection-filter-drawer-close-main');
var showresultmobilebtn = document.querySelector('.boost-pfs-filter-mobile-footer');

if (SortFilterMain) {
    SortFilterMain.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleState('#collection-filter-drawer', 'true', 'false');
        SortFilterDrawerMain.classList.add("show-filter-modal");
    };
}
if (SortFilterCloseMain) {
    SortFilterCloseMain.onclick = function(e) {
        toggleState('#collection-filter-drawer', 'true', 'false');
        SortFilterDrawerMain.classList.remove("show-filter-modal");
        e.stopPropagation();
        e.preventDefault();
    };
}

if (showresultmobilebtn) {
    showresultmobilebtn.onclick = function(e) {
        toggleState('#collection-filter-drawer', 'true', 'false');
        SortFilterDrawerMain.classList.remove("show-filter-modal");
        e.stopPropagation();
        e.preventDefault();
    };
}


if (SortFilterDrawerMain) {
    SortFilterDrawerMain.addEventListener('click', function(e) {
        e.stopPropagation();
    })
}
if (SortFilterDrawerMain) {
    document.body.addEventListener('click', function(e) {
        if (SortFilterDrawerMain.classList.contains('show-filter-modal')) {
            SortFilterDrawerMain.setAttribute("aria-hidden", "true");
        }
    });
}

window.onload = function() {

    var VariantClick = document.querySelectorAll(".options__Size .HorizontalList__Item .product-variant")
    if (VariantClick) {
        VariantClick.forEach(el => el.click());

        var FirstVariant = document.querySelector(".options__Size .HorizontalList__Item .product-variant");
        if (FirstVariant) {
            FirstVariant.click();
        }
    }
};

var productSkuNumber = document.querySelector('.ProductMeta__SkuNumber');
if (productSkuNumber) {
    document.addEventListener('variant:changed', function(event) {
        var variant = event.detail.variant.sku;
        productSkuNumber.innerText = variant;
    });

}

var cursorone = document.querySelector('.carousel-drag');
var cursordiv = document.querySelector('.NewCursor');

if (cursordiv) {
    cursordiv.addEventListener('mousemove', function(e) {
        cursorone.classList.add('visible');

    });
}
 
if (cursordiv) {
    cursordiv.addEventListener('mouseleave', function(e) {
        cursorone.classList.remove('visible');
    })
}



const cursor = document.querySelector('.carousel-drag');
const cursorCircle = document.querySelector('.carousel-drag svg');
if (cursor) {
    const mouse = {
        x: -100,
        y: -100
    }; // mouse pointer's coordinates
    const pos = {
        x: 0,
        y: 0
    }; // cursor's coordinates
    const speed = 0.8; // between 0 and 1

    const updateCoordinates = e => {
        mouse.x = e.clientX;
        mouse.y = e.clientY;
    }

    window.addEventListener('mousemove', updateCoordinates);


    function getAngle(diffX, diffY) {
        return Math.atan2(diffY, diffX) * 180 / Math.PI;
    }

    function getSqueeze(diffX, diffY) {
        const distance = Math.sqrt(
            Math.pow(diffX) + Math.pow(diffY)
        );
        const maxSqueeze = 0;
        const accelerator = 0;
        return Math.min(distance / accelerator, maxSqueeze);
    }


    var updateCursor = () => {
        const diffX = Math.round(mouse.x - pos.x);
        const diffY = Math.round(mouse.y - pos.y);

        pos.x += diffX * speed;
        pos.y += diffY * speed;

        const angle = getAngle(diffX, diffY);
        const squeeze = getSqueeze(diffX, diffY);

        const scale = 'scale(' + (1 + squeeze) + ', ' + (1 - squeeze) + ')';
        const rotate = 'rotate(' + angle + 'deg)';
        const translate = 'translate3d(' + pos.x + 'px ,' + pos.y + 'px, 0)';

        
       cursor.style.webkitTransform   = translate;
        cursorCircle.style.transform = rotate + scale;
       cursorCircle.style.webkitTransform = rotate + scale;
    };

    function loop() {
        updateCursor();
        requestAnimationFrame(loop);
    }

    requestAnimationFrame(loop);

}

var Bridel = document.querySelector('.Main_Bridel_slider');
if(Bridel){
var FlktyBridel = new Flickity(Bridel, {
    wrapAround: true,
    dragThreshold: false,
  draggable: false,
    pageDots: false,
    fade: true,
    prevNextButtons: false,
    contain: true,
  autoPlay: 3000
});


// previous
var previousButton = document.querySelectorAll('.button--previous-featured-bride');
if (previousButton) {
    previousButton.forEach(el => el.addEventListener('click', function() {
        FlktyBridel.previous();
    }))
};

// next
var nextButton = document.querySelectorAll('.button--next-featured-bride');
if (nextButton) {
    nextButton.forEach(el => el.addEventListener('click', function() {
        FlktyBridel.next();
    }))
};
}
//if ( window.matchMedia('(min-width:641px)').matches) {
  var ProductList = document.querySelector('.ProductList--carousel_Cus');
  if(ProductList){
   ProductList.classList.add('ProductList--carousel');
  const ProductListChild = ProductList.children;
for (let i = 0; i < ProductListChild.length; i++) {
   ProductListChild[i].classList.add('Carousel__Cell');
}

var ProductList = new Flickity(ProductList, {
    wrapAround: false,
    dragThreshold: 15,
    pageDots: false,
    fade: true,
    prevNextButtons: false,
    contain: true,
    groupCells: true
});


// previous
var previousButton = document.querySelectorAll('.button--previous-featured-ProductList');
if (previousButton) {
    previousButton.forEach(el => el.addEventListener('click', function() {
        ProductList.previous();
    }))
};

// next
var nextButton = document.querySelectorAll('.button--next-featured-ProductList');
if (nextButton) {
    nextButton.forEach(el => el.addEventListener('click', function() {
        ProductList.next();
    }))
};
 
  }
//}
var MainCollectionPageMenu = document.querySelectorAll('.Collection-page_mainNav [aria-haspopup].HorizontalList__Item');

if (MainCollectionPageMenu) {
  
  MainCollectionPageMenu.forEach(el => el.addEventListener('mouseover', e => {
    el.classList.add('is-expanded');
	var toggleState = function(elem, one, two) {
    var elem = elem;
    elem.setAttribute('aria-hidden', elem.getAttribute('aria-hidden') === one ? two : one);
};
  
     el.children.forEach(function (item) {
        toggleState(item, 'true', 'false');
          });
  }));
  
    MainCollectionPageMenu.forEach(el => el.addEventListener('mouseout', e => {
    el.classList.remove('is-expanded');
	var toggleState = function(elem, one, two) {
    var elem = elem;
    elem.setAttribute('aria-hidden', elem.getAttribute('aria-hidden') === one ? two : one);
};
     el.children.forEach(function (item) {
        toggleState(item, 'true', 'false');
          });
  }));

  
   
}
var navbar = document.getElementById('CollectionNavbar'); // Get The NavBar
var filtertop = document.querySelector('.CollectionToolbar--top');


document.addEventListener("DOMContentLoaded", function(){

  if(navbar){
    var last_scroll_top = 0;
    window.addEventListener('scroll', function() {
          let scroll_top = window.scrollY;
      //console.log("scrollTop" + scroll_top + "/" + last_scroll_top + "scrollTop")
         if(scroll_top <= last_scroll_top || scroll_top <= 0) {
              navbar.style.opacity='1';
	filtertop.style.opacity='1';
          }
          else {
              navbar.style.opacity='0';
    	filtertop.style.opacity='0';
          }
          last_scroll_top = scroll_top;
    }); 
    
  }


}); 

// // Get the position on the page of the SVG
// var svgLocation = document.querySelector(".BridalSVG").getBoundingClientRect();

// // Scroll offset that triggers animation start.
// // In this case it is the bottom of the SVG.
// var offsetToTriggerAnimation = svgLocation.y + svgLocation.height;

// // Function to handle the scroll event.
// // Add an event handler to the document for the "onscroll" event
// function scrollAnimTriggerCheck(evt)
// {
//   var viewBottom = window.scrollY + window.innerHeight;
//   if (viewBottom > offsetToTriggerAnimation) {
//     // Start the SMIL animation
//     var animate = document.querySelectorAll(".BridalSVGAnimation");
//     animate.forEach(el => el.beginElement());
//     // Remove the event handler so it doesn't trigger again
//     document.removeEventListener("scroll", scrollAnimTriggerCheck);
//   }
// }

// // Add an event handler to the document for the "onscroll" event
// document.addEventListener("scroll", scrollAnimTriggerCheck);

// 
// !function(n,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):n.Splitting=t()}(this,function(){"use strict"
// var u=document,l=u.createTextNode.bind(u)
// function d(n,t,e){n.style.setProperty(t,e)}function f(n,t){return n.appendChild(t)}function p(n,t,e,r){var i=u.createElement("span")
// return t&&(i.className=t),e&&(!r&&i.setAttribute("data-"+t,e),i.textContent=e),n&&f(n,i)||i}function h(n,t){return n.getAttribute("data-"+t)}function m(n,t){return n&&0!=n.length?n.nodeName?[n]:[].slice.call(n[0].nodeName?n:(t||u).querySelectorAll(n)):[]}function o(n){for(var t=[];n--;)t[n]=[]
// return t}function g(n,t){n&&n.some(t)}function c(t){return function(n){return t[n]}}var a={}
// function n(n,t,e,r){return{by:n,depends:t,key:e,split:r}}function e(n){return function t(e,n,r){var i=r.indexOf(e)
// if(-1==i)r.unshift(e),g(a[e].depends,function(n){t(n,e,r)})
// else{var u=r.indexOf(n)
// r.splice(i,1),r.splice(u,0,e)}return r}(n,0,[]).map(c(a))}function t(n){a[n.by]=n}function v(n,r,i,u,o){n.normalize()
// var c=[],a=document.createDocumentFragment()
// u&&c.push(n.previousSibling)
// var s=[]
// return m(n.childNodes).some(function(n){if(!n.tagName||n.hasChildNodes()){if(n.childNodes&&n.childNodes.length)return s.push(n),void c.push.apply(c,v(n,r,i,u,o))
// var t=n.wholeText||"",e=t.trim()
// e.length&&(" "===t[0]&&s.push(l(" ")),g(e.split(i),function(n,t){t&&o&&s.push(p(a,"whitespace"," ",o))
// var e=p(a,r,n)
// c.push(e),s.push(e)})," "===t[t.length-1]&&s.push(l(" ")))}else s.push(n)}),g(s,function(n){f(a,n)}),n.innerHTML="",f(n,a),c}var s=0
// var i="words",r=n(i,s,"word",function(n){return v(n,"word",/\s+/,0,1)}),y="chars",w=n(y,[i],"char",function(n,e,t){var r=[]
// return g(t[i],function(n,t){r.push.apply(r,v(n,"char","",e.whitespace&&t))}),r})
// function b(t){var f=(t=t||{}).key
// return m(t.target||"[data-splitting]").map(function(a){var s=a["🍌"]
// if(!t.force&&s)return s
// s=a["🍌"]={el:a}
// var n=e(t.by||h(a,"splitting")||y),l=function(n,t){for(var e in t)n[e]=t[e]
// return n}({},t)
// return g(n,function(n){if(n.split){var t=n.by,e=(f?"-"+f:"")+n.key,r=n.split(a,l,s)
// e&&(i=a,c=(o="--"+e)+"-index",g(u=r,function(n,t){Array.isArray(n)?g(n,function(n){d(n,c,t)}):d(n,c,t)}),d(i,o+"-total",u.length)),s[t]=r,a.classList.add(t)}var i,u,o,c}),a.classList.add("splitting"),s})}function N(n,t,e){var r=m(t.matching||n.children,n),i={}
// return g(r,function(n){var t=Math.round(n[e]);(i[t]||(i[t]=[])).push(n)}),Object.keys(i).map(Number).sort(x).map(c(i))}function x(n,t){return n-t}b.html=function(n){var t=(n=n||{}).target=p()
// return t.innerHTML=n.content,b(n),t.outerHTML},b.add=t
// var T=n("lines",[i],"line",function(n,t,e){return N(n,{matching:e[i]},"offsetTop")}),L=n("items",s,"item",function(n,t){return m(t.matching||n.children,n)}),k=n("rows",s,"row",function(n,t){return N(n,t,"offsetTop")}),A=n("cols",s,"col",function(n,t){return N(n,t,"offsetLeft")}),C=n("grid",["rows","cols"]),M="layout",S=n(M,s,s,function(n,t){var e=t.rows=+(t.rows||h(n,"rows")||1),r=t.columns=+(t.columns||h(n,"columns")||1)
// if(t.image=t.image||h(n,"image")||n.currentSrc||n.src,t.image){var i=m("img",n)[0]
// t.image=i&&(i.currentSrc||i.src)}t.image&&d(n,"background-image","url("+t.image+")")
// for(var u=e*r,o=[],c=p(s,"cell-grid");u--;){var a=p(c,"cell")
// p(a,"cell-inner"),o.push(a)}return f(n,c),o}),H=n("cellRows",[M],"row",function(n,t,e){var r=t.rows,i=o(r)
// return g(e[M],function(n,t,e){i[Math.floor(t/(e.length/r))].push(n)}),i}),O=n("cellColumns",[M],"col",function(n,t,e){var r=t.columns,i=o(r)
// return g(e[M],function(n,t){i[t%r].push(n)}),i}),j=n("cells",["cellRows","cellColumns"],"cell",function(n,t,e){return e[M]})
// return t(r),t(w),t(T),t(L),t(k),t(A),t(C),t(S),t(H),t(O),t(j),b})

// Splitting();


      // window.onload = function () {
      //       (function () {
      //           var visited = localStorage.getItem('visited');
      //           if (!visited) {
      //               //document.getElementById("#hideoverflow").style.display = "block";
      //              // document.getElementById(".CoverDiv").style.display = "block";
      //               localStorage.setItem('visited', true);
      //           }
      //       })();
      //   }


      //       window.addEventListener('scroll', function (event) {
      //           var depth, i, layer, layers, len, movement, topDistance, translate3d;
      //           topDistance = this.pageYOffset;
      //           layers = document.querySelectorAll("[data-type='parallax']");
      //           for (i = 0, len = layers.length; i < len; i++) {
      //               layer = layers[i];
      //               depth = layer.getAttribute('data-depth');
      //               movement = -(topDistance * depth);
      //               translate3d = 'translate3d(0, ' + movement + 'px, 0)';
      //               layer.style['-webkit-transform'] = translate3d;
      //               layer.style['-moz-transform'] = translate3d;
      //               layer.style['-ms-transform'] = translate3d;
      //               layer.style['-o-transform'] = translate3d;
      //               layer.style.transform = translate3d;
      //           }
      //       }); 


        (function () {
            window.addEventListener("scroll", function (event) {
                var depth, i, layer, layers, len, movement, topDistance, translate3d;
                topDistance = this.pageYOffset;
                layers = document.querySelectorAll("[data-type='parallax']");
                for (i = 0, len = layers.length; i < len; i++) {
                    layer = layers[i];
                    depth = layer.getAttribute("data-depth");
                    movement = -(topDistance * depth);
                    translate3d = "translate3d(0, " + movement + "px, 0)";
                    layer.style["-webkit-transform"] = translate3d;
                    layer.style["-moz-transform"] = translate3d;
                    layer.style["-ms-transform"] = translate3d;
                    layer.style["-o-transform"] = translate3d;
                    layer.style.transform = translate3d;
                }
            });
        }.call(this));

        // window.onload = function () {
        //     (function () {
        //         var visited = localStorage.getItem('visited');
        //         if (!visited) {
        //             document.getElementById("hideoverflow").style.display = "block";
        //             localStorage.setItem('visited', true);
        //         }
        //     })();
        // }


// gsap code

gsap.registerPlugin(ScrollTrigger)

const animationFunction = (elClass) => {
  // setting the initial state of the element
  gsap.set(elClass, { y: 100, opacity: 0 });

  //animating it using scrollTrigger
  gsap.to(elClass, {
    y: 0,
    opacity: 1,
    ease: 'expo',
    duration: 2,
    immediateRender: false,
    scrollTrigger: {
      trigger: elClass,
      start: 'top 85%',
    },
  });
};
animationFunction(".anim-text");
//oval-text-anim
animationFunction(".oval-anim");
//below-content-anim
animationFunction(".below-content-anim");
//text-anim-address
animationFunction(".text-anim-address");
//richtext-anim
animationFunction(".richtext-anim");



//intro-image
gsap.set('.intro-image', {y: 100, opacity: 0})
gsap.to(
  '.intro-image',
  { y: 0, opacity: 1, duration: 2, ease: 'expo', delay: .8 }
);


//Slideshow text animtion

const headingAnimation3 = () => {
gsap.set('.slideshow-content-anim', {y: 110, rotationZ: 10})

gsap.to('.slideshow-content-anim', 
{y: 0, 
 rotationZ: 0,
 duration: 2,
 ease: 'expo',
 delay: 4,
 stagger: 0.5,
 scrollTrigger: {
trigger: '.slideshow-content-anim',
start: 'top 85%'
}
}
       )
}
headingAnimation3();


// gsap.from(".ProductItem__Title", {
//   opacity: 0,
//   y: 200,
//   duration: 0.3
// });

// const h1 = document.querySelector("#product-item-id .ProductItem__Title");
// const hover = gsap.to(h1, {
//   color: "blue",
//   duration: 0.3,
//   stagger: 0.7,
//   ease: "ease-in-out",
//       scrollTrigger: {
//       trigger: h1,
//       start: 'top 95%',
//     },
// });

// h1.addEventListener("mouseenter", () => hover.play());



//.ProductItem__Image
const animationImageFunction = (elClass) => {
  // setting the initial state of the element
  gsap.set(elClass, { y: 100, opacity: 0 });

  //animating it using scrollTrigger
  gsap.to(elClass, {
    y: 0,
    opacity: 1,
    ease: 'expo',
    duration: 2,
    stagger: 0.7,
    scrollTrigger: {
      trigger: elClass,
      start: 'top 95%',
    },
  });
};
animationImageFunction("#shopify-section-template--16591951167705__1651210829e1d74a4f .ProductItem");
animationImageFunction("#shopify-section-template--16591951167705__1650967693579cc13e .ProductItem");
animationImageFunction("#shopify-section-template--16591951167705__1651922704988c6be1 .ProductItem");
animationImageFunction("#shopify-section-template--16338329436377__1663061229821620e9 .ProductItem");


// gsap-banner-parallax
 if ( window.matchMedia('(min-width:768px)').matches) {  
const animationImagepara = (elClass) => {
const parallaxTl = gsap.timeline({
  scrollTrigger: {
    trigger: elClass,
    scrub: 0.5,
    // start: '50px top',
    end: 'bottom center',
  },
});

parallaxTl.to(elClass, { y: -200 });
};
animationImagepara('.gsap-banner-parallax');
   
 }



// Slideshow Heading Animation

const newHeadingAnimationSlideShow = (headingClass) => {
const headings = gsap.utils.toArray(headingClass);

headings.forEach(heading => {
  let splitText = '';
  

  const splittedText = heading.innerText.split('');
 

  for(let i = 0; i < splittedText.length; i++) {
    splitText += '<div class="split__text__2" style="display: inline-block">' + splittedText[i] + '</div>'
  }

  heading.innerHTML = '';
  heading.innerHTML = splitText;

  gsap.set('.split__text__2', {y: 170});

    const headingsTl = gsap.timeline({
    scrollTrigger: {
      trigger: heading,
      start: 'top 70%',
    }
  })
headingsTl.to('.split__text__2', {y: 0, rotationZ: 0, duration: 1,delay: 1, stagger: 0.015, ease: 'expo'});
});
}
newHeadingAnimationSlideShow('.slideshow-anim');



// heading Split Animation

const newHeadingAnimation = (headingClass) => {
const headings = gsap.utils.toArray(headingClass);

headings.forEach(heading => {
  let splitText = '';
  

  const splittedText = heading.innerText.split('');
 

  for(let i = 0; i < splittedText.length; i++) {
    splitText += '<div class="split__text" style="display: inline-block">' + splittedText[i] + '</div>'
  }

  heading.innerHTML = '';
  heading.innerHTML = splitText;

  gsap.set('.split__text', {y: 160});

    const headingsTl = gsap.timeline({
    scrollTrigger: {
      trigger: heading,
      start: 'top 70%',
    }
  })
headingsTl.to('.split__text', {y: 0, rotationZ: 0, duration: 0.6, stagger: 0.015, ease: 'expo'});
});
}

newHeadingAnimation('.split-text-anim');
newHeadingAnimation('.bride-anim');
newHeadingAnimation('.faq-anim');

gsap.set('.split__text', {y: 160})



// Paragraph animation 

const paraLinesAnimation = (paraClass, containerClass) => {
  const paras = document.querySelectorAll(paraClass);


  paras.forEach((para) => {
    let paraSplit = '';

    const paraLinesSplit = para.innerText.split(' ');

    for (let i = 0; i < paraLinesSplit.length; i++) {
      paraSplit +=
        '<div class="split__word">' + paraLinesSplit[i] + '&nbsp;</div>';
    }

    para.innerHTML = '';

    para.innerHTML = paraSplit;
  });

   const paraTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: paras,
      start: 'top 65%',
    }
  })

  paraTimeline.fromTo('.split__word', {yPercent: 103, opacity: 0}, {yPercent: 0, opacity: 1, duration: 2, ease: 'power3', stagger: 0.02})

};

paraLinesAnimation('.split-para-anim');


// Touch expand marquee

// function addClassOnHover (elClass, ProductItem__Title) {
//     elements = document.querySelectorAll(elClass) 

//     elements.forEach(element => {
//         element.addEventListener('mouseover', () => {
//            element.classList.add('.marquee-title') 
//         }) 

//         element.addEventListener('mouseout', () => {
//             element.classList.remove('.without-marquee')
//         })
//     });
// }








